export default "__VITE_ASSET__bcb82405__"